import { useState, useEffect } from 'react';

// Custom Solution for BG Color change for Actions
export default function useScrollCheck(actionRef) {
  const [hasScroll, setHasScroll] = useState(false);
  useEffect(() => {
    if (actionRef.current) {
      setHasScroll(window.innerHeight < document.documentElement.scrollHeight);
    }
  }, [actionRef]);
  return hasScroll;
}